export const getRowAnimationDelay = (rowIndex: number) => {
  return 0.1 * (rowIndex + 1);
};
